// extracted by mini-css-extract-plugin
export default {"label":"styles_label__OSwcc","select":"styles_select__w4iyG"};